import { inject, ref, type Ref } from 'vue'
import { type ClientOrganisation, type ClientQuestionnaireSubmission } from '@/types/generated'

/**
 * This composable is used to get the theme color of the organisation for the V3 ClientPortal.
 * It uses Vue injections to get the theme color from the organisation or questionnaire.
 * If the theme color is not available then it will return the default color (purple).
 * It can be used to set the color by setting the class name, for example `bg-${themeColor.value}-500`.
 * @returns themeColor - The theme color of the organisation as a ref.
 */
export function useThemeColor() {
  const themeColor = ref<string>('iris')

  const org = inject<Ref<ClientOrganisation | null>>('org', ref(null))
  const accessToken = inject<string | null>('accessToken', null)
  const questionnaire = inject<Ref<ClientQuestionnaireSubmission | null>>(
    'questionnaire',
    ref(null)
  )

  if (!accessToken) {
    if (questionnaire?.value && 'theme_color' in questionnaire.value) {
      themeColor.value = (questionnaire.value as any).theme_color
    }
    return themeColor
  }

  if (questionnaire?.value && 'theme_color' in questionnaire.value) {
    themeColor.value = (questionnaire.value as any).theme_color
  } else if (org?.value?.theme) {
    themeColor.value = org.value.theme
  }

  return themeColor
}
